import { useMemo } from "react";

import { useRouteMatch } from "react-router-dom";

import isNumberLike from "../util/isNumberLike";

export const useSystemIdFromRoute = (): number | undefined => {
  const systemMatch = useRouteMatch<{ systemId?: string }>("/systems/:systemId");
  const organizationSystemMatch = useRouteMatch<{ systemId?: string }>(
    "/organizations/:organizationId/systems/:systemId",
  );
  const reportingSystemMatch = useRouteMatch<{ systemId?: string }>("/reporting/systems/:systemId");

  const systemId = Number(
    systemMatch?.params.systemId ??
      organizationSystemMatch?.params.systemId ??
      reportingSystemMatch?.params.systemId,
  );

  return useMemo<number | undefined>(() => {
    return isNumberLike(systemId) ? systemId : undefined;
  }, [systemId]);
};
